import {ReactElement} from 'react';
import {promoService} from 'services/promo';
import {useMount} from 'ui/effects/useMount';

type PromoConnectorProps = {
  promo?: PromoMessageService;
};

export const PromoConnector = ({promo = promoService}: PromoConnectorProps): ReactElement => {
  useMount(promo.init);
  return null;
};

export function usePromoVisible(): boolean {
  return promoService.isVisible();
}
